import type { InjectionKey, Ref } from 'vue';

export type IdRef = Readonly<{
    id: string;
    tabid: string;
    btnid: string;
}>;

export type TabPaneProps = Readonly<{
    title?: string;
}>;

export type TabPaneType = {
    idRef: IdRef;
    index: number;
    active: Ref<boolean | undefined>;
    props: TabPaneProps;
    visible: Ref<boolean | undefined>;
};

export type TabButtonProps = Readonly<{
    active?: boolean;
    visible?: boolean;
    title?: string;
    idRef: IdRef;
}>;

export const NavTabsParentKey = Symbol('NavTabsParent') as InjectionKey<NavTabsParent>;
export interface NavTabsParent {
    registerPane?: (pane: TabPaneType) => void;
    updatePane?: (idRef: IdRef, index: number) => void;
    unregisterPane?: (idRef: IdRef) => void;
}
